import ZendeskViews from "@/views/Misc/Zendesk/Index";
import ZendeskSuccess from "@/views/Misc/Zendesk/Success";
import ZendeskError from "@/views/Misc/Zendesk/Error";
import ZendeskInstallation from "@/views/Misc/Zendesk/Installation";
import Connection from "@/views/Misc/Zendesk/Connection";
import WidgetSettings from "@/views/Misc/Zendesk/WidgetSettings";

export default [
  {
    path: "/zendesk",
    name: "ZendeskViews",
    component: ZendeskViews,
    children: [
      {
        path: "oauth/success",
        name: "ZendeskSuccess",
        component: ZendeskSuccess,
      },
      {
        path: "oauth/error",
        name: "Error",
        component: ZendeskError,
      },
      {
        path: "install-widget",
        name: "InstallWidget",
        component: ZendeskInstallation,
      },
      {
        path: "connection",
        name: "Connection",
        component: Connection,
      },
      {
        path: "settings",
        name: "WidgetSettings",
        component: WidgetSettings,
      },
    ],
  },
];
